import { Box } from "@chakra-ui/react"
import { GuaranteeProps } from "@definitions/types"
import guarantee_arabic from "@public/lottie/guarantee_arabic.json"
import guarantee_english from "@public/lottie/guarantee_english.json"
import guarantee_german from "@public/lottie/guarantee_german.json"
import guarantee_mexican from "@public/lottie/guarantee_mexican.json"
import { useRouter } from "next/router"
import Lottie from "react-lottie-player/dist/LottiePlayerLight"

export default function Guarantee(props: GuaranteeProps) {
  const { loop, play, ...rest } = props
  const { locale } = useRouter()

  const lottieData = {
    ar: guarantee_arabic,
    en: guarantee_english,
    de: guarantee_german,
    "es-mx": guarantee_mexican,
  }

  const selectedAnimation =
    lottieData[locale as keyof typeof lottieData] || guarantee_english

  return (
    <Box {...rest}>
      <Lottie
        animationData={selectedAnimation}
        loop={loop}
        play={play}
      />
    </Box>
  )
}
